/**
 * Edit-mode guard для виджетов.
 *
 * В preview-iframe AI-редактора creator проставляет атрибут `data-plp-edit`
 * на `<html>`. Виджеты используют это, чтобы:
 *   - блокировать submit формы
 *   - ставить на паузу autoplay слайдера/таймеров
 *   - не открывать lightbox по клику (даём редактору выделить картинку)
 *
 * На production-страницах атрибута нет → `isEditMode() === false`.
 */

const EDIT_ATTR = 'data-plp-edit';

export function isEditMode(): boolean {
  return document.documentElement.hasAttribute(EDIT_ATTR);
}

/**
 * Подписка на изменение режима. Колбэк вызывается сразу с текущим
 * состоянием и далее на каждое появление/удаление атрибута.
 *
 * Возвращает функцию-отписку.
 */
export function onEditModeChange(cb: (edit: boolean) => void): () => void {
  const observer = new MutationObserver(() => cb(isEditMode()));
  observer.observe(document.documentElement, {
    attributes: true,
    attributeFilter: [EDIT_ATTR],
  });
  cb(isEditMode());
  return () => observer.disconnect();
}
